/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Flex, Box, Link, Button } from 'rebass';
import { Label, Input } from '@rebass/forms';

import { H4 } from '../Text';
import { Container } from '../Container';

import { useTranslation } from '../../i18n/TranslationContext';
import { LocalizedLink } from '../../components/LocalizedLink';

const JoinTheConvo = () => {
  const t = useTranslation();
  return (
    <Box>
      <H4>{t('footer_join_the_conversation')}</H4>
      <Flex flexDirection="column">
        <a
          href="mailto:interaction21@ixda.org"
          target="_blank"
          sx={{ mb: 3, variant: 'variants.link', display: 'block' }}
        >
          interaction21@ixda.org
        </a>
      </Flex>
    </Box>
  );
};

const SocialMediaSection = () => {
  const t = useTranslation();
  return (
    <Box>
      <H4>{t('footer_follow_the_movement')}</H4>
      <Box sx={{ display: 'inline-block' }}>
        <ul
          sx={{
            m: 0,
            p: 0,
            listStyle: 'none',
            columns: 2,
            li: { mb: 3 },
          }}
        >
          <li>
            <Link href="https://twitter.com/ixdconf" target="_blank">
              Twitter
            </Link>
          </li>
          <li>
            <Link href="https://instagram.com/ixdconf" target="_blank">
              Instagram
            </Link>
          </li>
          <li>
            <Link
              href="https://www.facebook.com/groups/ixdaglobal/"
              target="_blank"
            >
              Facebook
            </Link>
          </li>
          <li>
            <Link href="https://www.linkedin.com/company/ixda" target="_blank">
              LinkedIn
            </Link>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

const NewsletterSignupSection = () => {
  const t = useTranslation();
  return (
    <Box>
      <form
        action="https://ixda.us2.list-manage.com/subscribe?u=e714c585710f24c2743e2cb29&id=73b8a1afa1"
        method="post"
        name="mc-embedded-subscribe-form"
        target="_blank"
        sx={{ display: 'inherit' }}
      >
        <Label as={H4} htmlFor="email-sign-up" sx={{ variant: 'text.h4' }}>
          {t('footer_sub_to_our_newsletter')}
        </Label>
        <Flex flexDirection={['column', 'row']}>
          <Input
            type="email"
            placeholder={t('footer_enter_your_email')}
            flex="5"
            name="email-sign-up"
            sx={{
              borderTopLeftRadius: '4px',
              borderBottomLeftRadius: '4px',
              borderTopRightRadius: ['4px', 0],
              borderBottomRightRadius: ['4px', 0],
              fontFamily: 'body',
              borderColor: 'text',
              '::placeholder': { color: 'text' },
              height: ['32px', '48px'],
              lineHeight: ['32px', '48px'],
              mb: [2, 0, 0],
            }}
          />
          <Button
            type="submit"
            flex="3"
            name="subscribe"
            sx={{
              borderTopLeftRadius: ['4px', 0],
              borderBottomLeftRadius: ['4px', 0],
              height: ['32px', '48px'],
              lineHeight: ['32px', '36px'],
              cursor: 'pointer',
            }}
          >
            {t('footer_subscribe_btn')}
          </Button>
        </Flex>
      </form>
    </Box>
  );
};

const BecomeAPartnerSection = () => {
  const t = useTranslation();
  return (
    <LocalizedLink
      to="/get-involved"
      sx={{
        variant: 'buttons.primary',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        height: '48px',
        textAlign: 'left',
        width: ['100%', '100%', '80%'],
        cursor: 'pointer',
        mt: 3,
        p: 2,
      }}
    >
      {t('footer_get_involved')}
    </LocalizedLink>
  );
};

const CommunicateWithUs = () => (
  <Container>
    <Flex
      flexDirection={['column-reverse', 'column-reverse', 'row']}
      flexWrap="wrap"
    >
      <Flex
        flexDirection="column"
        width={[1, 1 / 2, 1 / 3]}
        justifyContent="space-between"
        mb={[4, 4, 0]}
      >
        <JoinTheConvo />
        <BecomeAPartnerSection />
      </Flex>
      <Flex
        flexDirection="column"
        width={[1, 1 / 2, 1 / 3]}
        justifyContent="space-between"
        mb={[4, 4, 0]}
      >
        <SocialMediaSection />
      </Flex>
      <Flex
        flexDirection="column"
        width={[1, 1, 1 / 3]}
        justifyContent="space-between"
        mb={[4, 4, 0]}
      >
        <NewsletterSignupSection />
      </Flex>
    </Flex>
  </Container>
);

export { CommunicateWithUs };
